import { useEffect, useMemo } from 'react'
import { Flex } from '@mantine/core'

import { ShadowBox } from '@/components/@Shared/ShadowBox/ShadowBox'
import type { GenderSummaryProps } from '@/components/@Shared/UserManagmentCharts/GenderSummary/GenderSummary.types'
import { Loader } from '@/components/Loader/Loader'
import { MultipleBarChart } from '@/components/MultipleBarChart/MultipleBarChart'
import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import {
  getGenderSections,
  getStats,
  getTotal,
} from '@/helpers/chartData.helper'

export function GenderSummary({
  data,
  isLoading,
  onUpdateChartsData,
}: GenderSummaryProps) {
  const sections = useMemo(() => {
    const stats = getStats(data)
    const total = getTotal(stats)

    return getGenderSections(stats, total)
  }, [data])

  useEffect(() => {
    if (!onUpdateChartsData) return

    const sectionsPDF = sections.map(section => ({
      color: section.color,
      name: section.label,
      value: section.initialValue,
    }))

    onUpdateChartsData(sectionsPDF, 'gender')
  }, [sections, onUpdateChartsData])

  return (
    <ShadowBox
      w={{
        base: '100%',
        lg: '70%',
      }}
    >
      <Title variant="h2">Gender</Title>

      {!sections.length ? (
        <Flex align="center" h={75} justify="center">
          {isLoading ? <Loader isMinimized /> : <Text>No data available</Text>}
        </Flex>
      ) : (
        <MultipleBarChart sections={sections} />
      )}
    </ShadowBox>
  )
}
